import React, { VFC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';
import ChatIcon from '@material-ui/icons/ChatOutlined';
import Styled from '../Styled';
import IconWithWord from './MuiIconWithWord';

import { ROOMS } from '../../../constants/routing';

const { IconWrapper, IconLink } = Styled;

interface Props {}
const ChatIconLink: VFC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <IconWrapper theme={theme}>
      <IconLink href={ROOMS}>
        <IconWithWord Icon={ChatIcon} word={t('header.menu.chat')} />
      </IconLink>
    </IconWrapper>
  );
};

export default ChatIconLink;
